import React, { useState, useContext, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import initializeChat from '@bb/chat';
import { Icon } from 'components';
import { AuthContext, LayoutContext } from 'contexts';
import { isContextualChatEnabled } from 'utils';
import ContextualChatButton from './ContextualChatButton';

const Chat: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    auth,
    toggleChatInactive,
    hasFeature = () => false,
  } = useContext(AuthContext);
  const { chatVisibility } = useContext(LayoutContext);

  const setActive = async () => {
    setIsLoading(true);
    const { value } = await Swal.fire({
      title: 'Chat Status',
      text: 'Would you like to set your chat status as ACTIVE?',
      type: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#707070',
      confirmButtonColor: '#4974C5',
      confirmButtonText: "Yes, I'm active",
      closeButtonHtml: 'No',
    });
    if (value) await toggleChatInactive();
    setIsLoading(false);
  };

  useEffect(() => {
    initializeChat();
  }, []);

  const contextualChatEnabled = useMemo(
    () => isContextualChatEnabled(auth?.org.mlsTypes),
    [auth.org.mlsTypes],
  );
  return (
    <>
      {!contextualChatEnabled && (
        <>
          {auth?.isChatInactive && (
            <StyledChatInactiveContainer
              id="brokerchat-inactive"
              onClick={setActive}
              $visible={chatVisibility}
            >
              {isLoading ? (
                <div>
                  <Icon type="antdLoadingOutlined" width={32} color="white" />
                </div>
              ) : (
                <Icon type="ban" color="white" width={32} />
              )}
            </StyledChatInactiveContainer>
          )}
          <StyledChatContainer
            id="brokerchat-root"
            className="pending-load"
            $visible={!auth?.isChatInactive && chatVisibility}
          />
        </>
      )}
      {hasFeature('CHAT') && contextualChatEnabled && auth.streamChatId && (
        <ContextualChatButton />
      )}
    </>
  );
};

export default Chat;

// Styled are copied from original angular css
const StyledChatInactiveContainer = styled.a<{ $visible?: boolean }>`
  padding: 14px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  z-index: 2147483645;
  background: #f67171;
  color: #fff;
  border-radius: 50%;
  transform-origin: center;
  backface-visibility: hidden;
  overflow: hidden;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-shadow:
    0 1px 6px rgba(0, 0, 0, 0.06),
    0 2px 32px rgba(0, 0, 0, 0.16) !important;
  ${({ $visible }) => !$visible && 'display: none !important'};
`;

const StyledChatContainer = styled.div<{ $visible?: boolean }>`
  ${({ $visible }) => !$visible && 'display: none !important'};
`;
